import { ChangeDetectionStrategy, Component, Input, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { TiimeIconModule, TiimeTooltipModule } from 'tiime-material';

import { GICachedDataApiService } from '@gi/api/services/gi-cached-data-api.service';
import { TiimeBusinessProAccountIntention } from '@gi/enums/tiime-business-pro-account-intention.enum';
import { CodeAndLabel } from '@models/code-and-label';
import { CodeAndLabelPipe } from '@shared-pipes/code-and-label/code-and-label.pipe';

@Component({
  selector: 'app-tiime-business-pro-account-intention-icon',
  standalone: true,
  imports: [TiimeIconModule, TiimeTooltipModule, CodeAndLabelPipe],
  templateUrl: './tiime-business-pro-account-intention-icon.component.html',
  styleUrl: './tiime-business-pro-account-intention-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TiimeBusinessProAccountIntentionIconComponent {
  @Input({ required: true }) tiimeBusinessProAccountIntention: TiimeBusinessProAccountIntention;

  readonly tiimeBusinessProAccountIntentions: Signal<CodeAndLabel<TiimeBusinessProAccountIntention>[]> = toSignal(
    this.gICachedDataApiService.getTiimeBusinessProAccountIntentions()
  );
  readonly TiimeBusinessProAccountIntention = TiimeBusinessProAccountIntention;

  constructor(private readonly gICachedDataApiService: GICachedDataApiService) {}
}
